var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistrictIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "139px",
    viewBox: "0 0 160 139",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0EA6E9F2-CCE8-4C22-A25D-0E969C35DE8B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groups",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups-/-My-groups-/-Create-a-group-(For-Creater)",
    transform: "translate(-620.000000, -522.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(200.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dialog"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups-list",
    transform: "translate(63.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "District",
    transform: "translate(312.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "District-icon",
    transform: "translate(45.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company-icon",
    transform: "translate(0.000000, 0.666667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001-visit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7367747,4.59617659 L61.7367747,2 C61.7367747,0.8954305 60.8413442,-2.02906125e-16 59.7367747,0 L15.537542,-4.4408921e-16 C14.4329725,-1.22223788e-15 13.537542,0.8954305 13.537542,2 L13.537542,4.62285203 C13.537542,5.72742153 12.6421115,6.62285203 11.537542,6.62285203 L2.17344061,6.62285203 C1.06887111,6.62285203 0.173440609,7.51828253 0.173440609,8.62285203 L0.173440609,94.2389452 L72.8815633,94.2389452 C73.9861328,94.2389452 74.8815633,93.3435147 74.8815633,92.2389452 L74.8815633,8.62722756 C74.8815633,7.52530719 73.9902632,6.63097783 72.8883492,6.62723907 L63.7299888,6.59616508 C62.6280748,6.59242632 61.7367747,5.69809696 61.7367747,4.59617659 Z",
    id: "Shape",
    fill: "#49853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4023476,74.0640934 L42.7887438,74.0640934 C43.8933133,74.0640934 44.7887438,74.9595239 44.7887438,76.0640934 L44.7887438,94.2367589 L30.4023476,94.2367589 L30.4023476,76.0640934 C30.4023476,74.9595239 31.2977781,74.0640934 32.4023476,74.0640934 Z",
    id: "Rectangle-path",
    fill: "#37633A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 21.4264684,
    y: 47.4856719,
    width: 12.7065998,
    height: 6.57847085
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(21.415765, 21.425395)",
    fill: "#37633A"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0107035137,
    y: 39.2172184,
    width: 12.7065998,
    height: 6.57847085
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0107035137,
    y: 0.0502840909,
    width: 12.7065998,
    height: 6.57847085
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0107035137,
    y: 13.2050395,
    width: 12.7065998,
    height: 6.57847085
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFDA2D",
    x: 41.5820585,
    y: 21.4756793,
    width: 12.7065998,
    height: 6.57847085
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_1_",
    fill: "#37633A",
    x: 41.5820585,
    y: 47.4856719,
    width: 12.7065998,
    height: 6.57847085
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_1_1_",
    fill: "#FEF192",
    x: 41.5820585,
    y: 60.6426136,
    width: 12.7065998,
    height: 6.57847085
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 41.5820585,
    y: 21.4756793,
    width: 12.7065998,
    height: 6.57847085
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_2_1_",
    fill: "#37633A",
    x: 41.5820585,
    y: 34.6304348,
    width: 12.7065998,
    height: 6.57847085
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Company-icon",
    transform: "translate(103.733333, 26.533333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001-visit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.357507,2.95813782 L46.357507,2 C46.357507,0.8954305 45.4620765,-2.02906125e-16 44.357507,0 L12.1652006,0 C11.0606311,1.18396092e-15 10.1652006,0.8954305 10.1652006,2 L10.1652006,2.97649333 C10.1652006,4.08106283 9.26977006,4.97649333 8.16520056,4.97649333 L2.13023476,4.97649333 C1.02566526,4.97649333 0.130234764,5.87192383 0.130234764,6.97649333 L0.130234764,70.8123147 L54.2277931,70.8123147 C55.3323626,70.8123147 56.2277931,69.9168842 56.2277931,68.8123147 L56.2277931,6.97809242 C56.2277931,5.87617389 55.3364959,4.9818453 54.2345837,4.97810394 L48.3507164,4.95812629 C47.2488042,4.95438494 46.357507,4.06005635 46.357507,2.95813782 Z",
    id: "Shape",
    fill: "#49853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8288091,55.6526803 L31.6314055,55.6526803 C32.735975,55.6526803 33.6314055,56.5481108 33.6314055,57.6526803 L33.6314055,70.8106719 L22.8288091,70.8106719 L22.8288091,57.6526803 C22.8288091,56.5481108 23.7242396,55.6526803 24.8288091,55.6526803 Z",
    id: "Rectangle-path",
    fill: "#37633A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 16.088914,
    y: 35.6813241,
    width: 9.54125466,
    height: 4.94314476
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.080877, 16.099308)",
    fill: "#37633A"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.00803715796,
    y: 29.4683053,
    width: 9.54125466,
    height: 4.94314476
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.00803715796,
    y: 0.0377840909,
    width: 9.54125466,
    height: 4.94314476
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.00803715796,
    y: 9.92243083,
    width: 9.54125466,
    height: 4.94314476
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFDA2D",
    x: 31.2235386,
    y: 16.1370924,
    width: 9.54125466,
    height: 4.94314476
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_1_",
    fill: "#37633A",
    x: 31.2235386,
    y: 35.6813241,
    width: 9.54125466,
    height: 4.94314476
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_1_1_",
    fill: "#FEF192",
    x: 31.2235386,
    y: 45.5676136,
    width: 9.54125466,
    height: 4.94314476
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 31.2235386,
    y: 16.1370924,
    width: 9.54125466,
    height: 4.94314476
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_2_1_",
    fill: "#37633A",
    x: 31.2235386,
    y: 26.0217391,
    width: 9.54125466,
    height: 4.94314476
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(28.266667, 35.333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 4.8,
    y: 37.0666667,
    width: 98.4,
    height: 61.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 93.6,
    y: 46.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 93.6,
    y: 62.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 93.6,
    y: 78.6666667,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 83.4666667,
    y: 46.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 83.4666667,
    y: 62.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 83.4666667,
    y: 78.6666667,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 73.8666667,
    y: 46.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 73.8666667,
    y: 62.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 73.8666667,
    y: 78.6666667,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3276437,18.6666667 L20.6723563,18.6666667 C20.0693915,18.6666667 19.4986078,18.9386965 19.1188554,19.4070496 L4.8,37.0666667 L103.2,37.0666667 L88.8811446,19.4070496 C88.5013922,18.9386965 87.9306085,18.6666667 87.3276437,18.6666667 Z",
    id: "Shape",
    fill: "#37633A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0326265,15.4666667 C72.0326265,15.4666667 67.7578657,7.81663088 60.0631463,12.4731293 C57.8396113,13.8187315 58.4601734,10.5158663 54.9333333,13.3793512 L54.9333333,0.166595086 C54.9333333,0.166595086 55.2467359,5.05573713 62.7349342,1.38628991 C64.8678197,0.341207302 68.0785102,-0.831077975 72.0326265,0.831883173 C72.0326265,0.831883173 75.5592168,6.15341066 72.0326265,15.4666667 Z",
    id: "Shape",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 52.5333333,
    y: 0.266666667,
    width: 2.66666667,
    height: 24.2666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0666667,31.2043369 L69.0666667,98.6666667 L38.4,98.6666667 L38.4,31.2043369 L38.4,30.3565742 C38.4,29.6681292 38.7540795,29.028078 39.3372965,28.6622716 L52.6706298,20.2993146 C53.3204742,19.891718 54.1461925,19.891718 54.7960368,20.2993146 L68.1293702,28.6622716 C68.7125872,29.028078 69.0666667,29.6681292 69.0666667,30.3565742 L69.0666667,31.2043369 Z",
    id: "Shape",
    fill: "#FEF192"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 0,
    y: 98.6666667,
    width: 108,
    height: 4.26666667,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4666667,78.6666667 L58.2666667,78.6666667 C59.3712362,78.6666667 60.2666667,79.5620972 60.2666667,80.6666667 L60.2666667,98.4 L47.4666667,98.4 L47.4666667,80.6666667 C47.4666667,79.5620972 48.3620972,78.6666667 49.4666667,78.6666667 Z",
    id: "Rectangle-path",
    fill: "#37633A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 28.8,
    y: 46.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 28.8,
    y: 62.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 28.8,
    y: 78.6666667,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 18.9333333,
    y: 46.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 18.9333333,
    y: 62.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 18.9333333,
    y: 78.6666667,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 9.33333333,
    y: 46.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 9.33333333,
    y: 62.9333333,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 9.33333333,
    y: 78.6666667,
    width: 5.86666667,
    height: 10.1333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 42.6666667,
    y: 55.2,
    width: 8.8,
    height: 7.73333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 55.7333333,
    y: 55.2,
    width: 8.8,
    height: 7.73333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 42.6666667,
    y: 66.1333333,
    width: 8.8,
    height: 7.73333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 56,
    y: 66.1333333,
    width: 8.8,
    height: 7.73333333,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(43.200000, 27.466667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46666667,18.9333333 C4.2382295,18.9333333 0,14.6950166 0,9.46647155 C0,4.23831676 4.2382295,0 9.46666667,0 C14.6951038,0 18.9333333,4.23831676 18.9333333,9.46647155 C18.9333333,14.6950166 14.6951038,18.9333333 9.46666667,18.9333333 Z",
    id: "Shape",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46666667,17.5044025 C5.02771764,17.5044025 1.42893082,13.9059732 1.42893082,9.46643631 C1.42893082,5.02736013 5.02771764,1.42893082 9.46666667,1.42893082 C13.9056157,1.42893082 17.5044025,5.02736013 17.5044025,9.46643631 C17.5044025,13.9059732 13.9056157,17.5044025 9.46666667,17.5044025 Z",
    id: "Shape",
    fill: "#FEF192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46666667,5.71572327 C9.07222972,5.71572327 8.75220126,5.36803167 8.75220126,4.93862285 L8.75220126,3.99219476 C8.75220126,3.56317878 9.07222972,3.21509434 9.46666667,3.21509434 C9.86110361,3.21509434 10.1811321,3.56317878 10.1811321,3.99219476 L10.1811321,4.93862285 C10.1811321,5.36803167 9.86110361,5.71572327 9.46666667,5.71572327 Z",
    id: "Shape",
    fill: "#49853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46666667,15.8968553 C9.07222972,15.8968553 8.75220126,15.548771 8.75220126,15.119755 L8.75220126,14.1733269 C8.75220126,13.7439179 9.07222972,13.3962264 9.46666667,13.3962264 C9.86110361,13.3962264 10.1811321,13.7439179 10.1811321,14.1733269 L10.1811321,15.119755 C10.1811321,15.548771 9.86110361,15.8968553 9.46666667,15.8968553 Z",
    id: "Shape",
    fill: "#49853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2983712,10.1811321 L14.3519431,10.1811321 C13.9229271,10.1811321 13.5748428,9.8613839 13.5748428,9.46648598 C13.5748428,9.07194934 13.9229271,8.75220126 14.3519431,8.75220126 L15.2983712,8.75220126 C15.7277802,8.75220126 16.0754717,9.07194934 16.0754717,9.46648598 C16.0754717,9.8613839 15.7277802,10.1811321 15.2983712,10.1811321 Z",
    id: "Shape",
    fill: "#49853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2028649,10.3597484 L9.51701862,10.3597484 C9.09478373,10.3597484 8.75220126,10.002381 8.75220126,9.56102236 L8.75220126,7.94338015 C8.75220126,7.50202136 9.09478373,7.14465409 9.51701862,7.14465409 C9.93925351,7.14465409 10.281836,7.50242524 10.281836,7.94338015 L10.281836,8.76270018 L11.2024782,8.76270018 C11.6250998,8.76270018 11.9672956,9.12006746 11.9672956,9.56102236 C11.9672956,10.002381 11.6250998,10.3597484 11.2028649,10.3597484 Z",
    id: "Shape",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93862292,10.1811321 L3.99219479,10.1811321 C3.56278585,10.1811321 3.21509434,9.8613839 3.21509434,9.46648598 C3.21509434,9.07194934 3.56278585,8.75220126 3.99219479,8.75220126 L4.93862292,8.75220126 C5.36763891,8.75220126 5.71572327,9.07194934 5.71572327,9.46648598 C5.71572327,9.8613839 5.36763891,10.1811321 4.93862292,10.1811321 Z",
    id: "Shape",
    fill: "#49853F"
  })))))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistrictIcon);
export default __webpack_public_path__ + "static/media/district-icon.3dcece11a5e4dad9ba25a82dd24fdc80.svg";
export { ForwardRef as ReactComponent };